import _ from "underscore";
import React from "react";
import PropTypes from "prop-types";
import basicUtils from "../../utils/basic-utils";

const { func, string } = PropTypes;

export default class GlobalKeypress extends React.Component {
  static displayName = "GlobalKeypress";

  static propTypes = {
    onKeydown: func,
    onEscape: func,
  };

  static defaultProps = {
    onKeydown: basicUtils.noop,
    onEscape: basicUtils.noop,
  };

  componentDidMount() {
    document.body.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.body.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = evnt => {
    if (evnt.key === "Escape") {
      this.props.onEscape(evnt);
    } else {
      this.props.onKeydown(evnt);
    }
  };

  render() {
    return this.props.children || null;
  }
}
